import React from "react";
import SignupPage from "../Components/signup";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const Signup = () => {
  return (
    <div>
      <Navbar />
      <SignupPage />
      <Footer />
    </div>
  );
};

export default Signup;
